import React from "react";
import ApiUtils from "../../../utils/api_utils";
import { Row, Col, ListGroup } from "react-bootstrap";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const TopLeaderboard = (p) => {
  const dataTopThree = p.dataLeaderboard?.top_three_ranked_users;
  return (
    <div className="top-leaderboard-rank">
      <Row className="top-three-wrapper">
        {dataTopThree &&
          dataTopThree?.map((a, index) => (
            <Col
              xs={4}
              sm={4}
              md={4}
              className="top-three-image-wrapper text-center"
              key={index}
            >
              <div className="top-three-image">
                <img
                  src={
                    a.thumbnail_image_url
                      ? ApiUtils.validateImgUrl({ url: a.thumbnail_image_url })
                      : Assets.iconProfile
                  }
                  alt="top-three-image"
                  className="top-lead-img"
                />
                <div className="top-lead-badge">{a.rank}</div>
              </div>
              <div className="top-three-name">
                <span>
                  {a.first_name} {a.last_name}
                </span>
              </div>
              <div className="top-three-point">
                <span>{a.total_points_label}</span>
              </div>
              <div className="top-three-tier">
                <span>{a.tier_name.toUpperCase()}</span>
              </div>
            </Col>
          ))}
      </Row>
    </div>
  );
};

const UsersLeaderboard = (p) => {
  const dataRankedUsers = p.dataLeaderboard?.ranked_users;
  const currentUsers = p.dataLeaderboard?.current_user_rank;
  return (
    <div className="users-leaderboard-wrapper">
      <TopLeaderboard {...p} />
      {dataRankedUsers &&
        dataRankedUsers?.map((a, index) => (
          <ListGroup
            key={index}
            className={`${a.pk == currentUsers.pk ? "is-user" : ""}`}
          >
            <ListGroup.Item
              className={`${a.pk == currentUsers.pk ? "is-user" : ""}`}
            >
              <Row>
                <Col xs={1} sm={1} md={1} className="leaderboard-count">
                  {a.rank}
                </Col>
                <Col xs={3} sm={3} md={3}>
                  <img
                    src={
                      a.thumbnail_image_url
                        ? ApiUtils.validateImgUrl({
                            url: a.thumbnail_image_url,
                          })
                        : Assets.iconProfile
                    }
                    className="leaderboard-img"
                    alt="leaderboard_image"
                  />
                </Col>
                <Col xs={5} sm={5} md={5}>
                  <div className="leaderboard-fullname">
                    {a.first_name} {a.last_name}
                  </div>
                  <div className="leaderboard-tier">
                    {a.tier_name.toUpperCase()}
                  </div>
                </Col>
                <Col xs={3} sm={3} md={3} className="leaderboard-total">
                  {a.total_points_label}
                </Col>
              </Row>
            </ListGroup.Item>
          </ListGroup>
        ))}
    </div>
  );
};

export default UsersLeaderboard;
